export default "__VITE_ASSET__193aa260__"